module.exports = __webpack_public_path__ + "static/media/4.532bfc81.jpg";